import { IconButton, Tooltip } from "@mui/material";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import useActas from "../../../api/actas";
import { Badge, Button } from "react-bootstrap";
import ErrorIcon from "@mui/icons-material/Error";
import { EyeIcon } from "../../../components/Icons";
import PrintIcon from "@mui/icons-material/Print";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";


const AccionesActaTable = ({ id, alertas, estado_id, actaFisica, acta, setActaAImprimir, user_id_asignado, estado, setActaADesasignar }) => {

    const {
        coleccionActasDetalle,
        setAllActaDetalle,
    } = useActaDetalleStore();

    const {
        handlerModal,modals
    } = useGeneralAppStore();

    const {
        getActaChequear,
        getActaDetalle,
        quitarNotificadorAsignado
    } = useActas();


    return (
        <>
            <div className="d-flex gap-2 align-items-center position-relative">
                <Tooltip title="Ver detalle" arrow>
                    <IconButton
                        onClick={() => {
                            const actaDetalle = coleccionActasDetalle?.find(
                                (acta) => acta?.acta.id == id
                                // (acta) => acta?.acta.id == params.row.id
                            );
                            if (actaDetalle) {
                                setAllActaDetalle(actaDetalle);
                                handlerModal({ modal: true, modalName: "acta_detalle" });
                            } else {
                                if(estado_id == 3){
                                    getActaChequear(id);
                                }else{
                                    getActaDetalle(id);
                                }
                            }
                        }}
                    >
                        <EyeIcon color={acta?.baja_tribunal == 1 && "#fff"}/>
                    </IconButton>
                </Tooltip>
                {alertas?.length > 0 && (
                    // {params.row.alertas?.length > 0 && (
                    <Tooltip arrow title={`${alertas.length} Alertas `} className="position-absolute" style={{right:"-20px"}}>
                        {/* <Tooltip arrow title={`${params.row.alertas?.length} Alertas `}> */}
                        <div className="position-relative">
                            <ErrorIcon sx={{ color: "#DC3545 !important" }} />
                            <Badge bg="danger" className="position-absolute" style={{ fontSize: "10px" }}>
                                {alertas.length}
                                {/* {params.row.alertas?.length} */}
                            </Badge>
                        </div>
                    </Tooltip>
                )}

                {actaFisica && estado_id === 10 ? (

                    <Tooltip
                        title="Marcar como impresa"
                        placement="right"
                        slotProps={{
                            popper: {
                                modifiers: [
                                    {
                                        name: "offset",
                                        options: {
                                            offset: [0, -14],
                                        },
                                    },
                                ],
                            },
                        }}
                        arrow
                    >
                        <Button
                            variant="outline"
                            onClick={() => {
                                setActaAImprimir(acta);
                                handlerModal({ modal: true, modalName: "marcar_impresa" });
                            }}
                        >
                            <PrintIcon sx={{ color: "#1334C9" }} />
                        </Button>
                    </Tooltip>
                ) : null}
                {
                    estado_id == 8 &&
                    <Tooltip title="Desasignar acta" arrow>
                        <IconButton
                            onClick={() => {
                                handlerModal({modal:true, modalName:"modal_desasignar_acta"})
                                setActaADesasignar(acta)
                                // quitarNotificadorAsignado({
                                //     acta_id: id,
                                //     user_id_asignado: user_id_asignado,
                                // });

                                // console.log(params.row.user_id_asignado);
                                // console.log(params.row.id);
                            }}
                        >
                            <DoNotDisturbIcon color="error" />
                        </IconButton>
                    </Tooltip>
                }
                {/* <Link to={`${location.pathname}/${params.row.id}`} style={{ textDecoration: "none" }}>
                <EyeIcon /> Ver detalle
              </Link> */}
            </div>
        </>
    );
}
export default AccionesActaTable;